import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-borrowedbasedamount',
  templateUrl: './borrowedbasedamount.component.html',
  styleUrls: ['./borrowedbasedamount.component.css']
})
export class BorrowedbasedamountComponent implements OnInit {
  @Input('repaymentbased') repaymentbased = {
    settings_type:'',
    min_of_repayments:'',
    increment_type:'',
    percentage_increase:'',
    amount_increase:'',
    increment_type_duration:'',
    percentage_increase_duration:'',
    amount_increase_duration:'',
    increment_type_rate:'',
    increment_type_rate_value:'',
    fixed_increment_type:[],
    enable_amount_based_increase: false,

  }
  fixed = {
    max_amount:'', 
    max_duration:'',
    rate_ratio:'',
    repayments:''
  }
  @Output() saveSettings = new EventEmitter();
  @Input('loading') loading  = false;
  constructor() { }

  ngOnInit() {
  }
  save(){
    this.saveSettings.emit({repaymentbased: this.repaymentbased});
  }
  deleteBand(i){
    this.repaymentbased.fixed_increment_type.splice(i,1);
  }
  saveInterestRateBand(value, valid){
    this.repaymentbased.fixed_increment_type.push(value);
  }
  saveFixedRepayment(){
    this.saveSettings.emit({repaymentbased: this.repaymentbased});
  }
}
